<template>
  <edit-search-btn
    v-if="postSearch"
    :post-search-id="postSearch.id"
    title="Manage Flags"
    v-bind="$attrs"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { PostSearch } from '@/type';
import EditSearchBtn from '../search/EditSearchBtn.vue';
import { findFlaggingSearch } from '.';

interface Data {
  postSearch: PostSearch|null
}

export default defineComponent({
  components: {
    EditSearchBtn,
  },
  props: {
    clientId: {
      type: Number,
      required: true,
    },
  },
  data(): Data {
    return {
      postSearch: null,
    };
  },
  watch: {
    clientId: {
      handler() {
        this.load();
      },
      immediate: true,
    },
  },
  methods: {
    async load() {
      this.postSearch = await findFlaggingSearch(this.clientId);
    },
  },
});
</script>
